import React from 'react';
import GridLayout from './Layouts/GridLayout';
import ListLayout from './Layouts/ListLayout';
import MobileLayout from './Layouts/MobileLayout';
import DetailLayout from './Layouts/DetailLayout';

const layouts = {
  grid: GridLayout,
  list: ListLayout,
  mobile: MobileLayout,
  detail: DetailLayout,
  default: GridLayout,
};

const LayoutContainer = ({ type, children, searching }) => {
  return layouts && layouts[type] !== undefined
    ? React.createElement(layouts[type], { searching }, children)
    : React.createElement(layouts.default, null, children);
};

export default LayoutContainer;
